export enum RouteEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // google redirect
  GOOGLE_REDIRECT = '/google',
  REDIRECT = '/redirect',

  RESET_PAGE = '/reset',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  JOIN_TEAM_BRIDGE = '/joinTeamBridge',
  EMAIL_AUTHENTICATION = '/emailAuthentication',

  PREVIEW = '/preview',
  PDF = '/pdf',
  NOTIFY = '/notify',
  NOTIFY_INDEX = '/notify/index',

  // basic home path
  RECENTS = '/recents',
  RECENTS_INDEX = '/recents/index',

  PROFILE = '/profile',
  PROFILE_INDEX = '/profile/index',

  TEAM = '/team',

  TEAM_GROUP_INFO = '/team/groupInfo',
  TEAM_MANAGEMENT = '/team/management',
  TEAM_BILLING = '/team/billing',
  TEAM_STORAGE = '/team/storage',
  TEAM_API = '/team/api',
  TEAM_COMMENTS = '/team/comments',
  TEAM_SETTING = '/team/setting',
  TEAM_PAY_SUCCESS = '/team/paySuccess',
  TEAM_PAY_FAILED = '/team/payFailed',
  TEAM_SUBSCRIPTION_SUCCESS = '/team/subscriptionSuccess',

  DATASETS = '/datasets',
  DATASETS_LIST = '/datasets/list',
  DATASETS_DATA = '/datasets/data',
  DATASETS_TRASH = '/datasets/trash',
  DATASETS_QA_DATA = '/datasets/qa-data',
  DATASETS_OVERVIEW = '/datasets/overview',
  DATASETS_RULES = '/datasets/rules',
  DATASETS_QUA_CHECK_JOBS = '/datasets/QualityCheckJobs',
  DATASETS_CREATE_RUN = '/datasets/createRun',
  DATASETS_REPORT = '/datasets/report',
  DATASETS_CLASS = '/datasets/class',
  DATASETS_CLASSIFICATION = '/datasets/classification',
  DATASETS_DETAIL = '/datasets/detail',

  WORKBENCH = '/workbench',

  ONTOLOGY = '/ontology',
  ONTOLOGY_CENTER = '/ontology/center',
  ONTOLOGY_CLASS = '/ontology/class',
  ONTOLOGY_CLASSIFICATION = '/ontology/classification',

  MODELS = '/models',
  MODELS_DETAIL = '/models/detail',
  MODELS_LIST = '/models/list',

  TASK = '/task',
  TASK_INDEX = '/task/index',
  TASK_CONFIG = '/task/config',
  TASK_DETAIL = '/task/detail',
  TASK_DETAIL_WORKER = '/task/detail-worker',
  TASK_DETAIL_PARTNER = '/task/detail-partner',
  TASK_COUNTDOWN = '/task/countdown',
  TASK_PERFORMANCE = '/task/performance',
  TASK_BATCHCONFIG_BASIC = '/task/batch-config-basic',
  TASK_BATCHCONFIG_ONTOLOGY = '/task/batch-config-ontology',
  TASK_BATCHCONFIG_WORKFLOW = '/task/batch-config-workflow',
  TASK_BATCHCONFIG_QA = '/task/batch-config-qa',

  PROJECT = '/project',
  PROJECT_INDEX = '/project/index',
  PROJECT_DETAIL = '/project/detail',
  PROJECT_DETAIL_BATCHCONFIG_BASIC = '/project/detail/batch-config-basic',
  PROJECT_DETAIL_BATCHCONFIG_ONTOLOGY = '/project/detail/batch-config-ontology',
  PROJECT_DETAIL_BATCHCONFIG_QA = '/project/detail/batch-config-qa',
  PROJECT_DETAIL_BATCHCONFIG_WORKFLOW = '/project/detail/batch-config-workflow',

  PROJECT_DETAIL_PERFORMANCE = '/project/performance',
  PROJECT_DETAIL_QUALITY = '/project/quality',
}
